<template>
  <p class="markdown" v-html="changelog"></p>
</template>

<script>
import { markdown } from "markdown";

export default {
  name: "markdown",

  props: {
    data: String
  },

  computed: {
    changelog() {
      return markdown.toHTML(this.data);
    }
  }
};
</script>

<style lang="scss" scoped>
.markdown ::v-deep {
  h3 {
    color: #fff;
    font-size: 2rem;
    text-transform: uppercase;
    font-weight: bold;
    margin-top: 14px;
    letter-spacing: 4px;
    margin-bottom: 10px;
  }

  ol,
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    position: relative;
    margin-bottom: 10px;
    padding-left: 15px;
    color: rgba(255, 255, 255, 0.5);
  }

  li:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 0;
    width: 4px;
    height: 1px;
    background: rgba(255, 255, 255, 0.5);
  }

  p {
    color: rgba(255, 255, 255, 0.5);
    display: block;
    margin-bottom: 10px;
  }

  a {
    color: #2492e9;
    text-decoration: none;
  }

  a:hover {
    color: #2492e9;
    text-decoration: underline;
  }
}
</style>
